import api from '../../../app/api';
import deleteCompanyOwner from '../../company-owner/services/delete-company-owner';
import getCompanyOwners from '../../company-owner/services/get-company-owners';
import getCompanyOwnersWithJoin from './get-company-owners-with-join';
import addCompanyOwner from './add-company-owner';
import editCompanyOwner from './edit-company-owner';
import getCompanyOwner from './get-company-owner';

export const accountsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCompanyOwners: getCompanyOwners(build),
        deleteCompanyOwner: deleteCompanyOwner(build),
        getCompanyOwnersWithJoin: getCompanyOwnersWithJoin(build),
        addCompanyOwner: addCompanyOwner(build),
        editCompanyOwner: editCompanyOwner(build),
        getCompanyOwner: getCompanyOwner(build),
    }),
});

export const {
    useDeleteCompanyOwnerMutation,
    useGetCompanyOwnersQuery,
    useGetCompanyOwnersWithJoinQuery,
    useAddCompanyOwnerMutation,
    useEditCompanyOwnerMutation,
    useGetCompanyOwnerQuery,
} = accountsApi;
